/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Section_MessagingInputs */

const cs_integrations_section_messaging = /** @type {(inputs: Integrations_Section_MessagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS`)
};

const en_integrations_section_messaging = /** @type {(inputs: Integrations_Section_MessagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS`)
};

/**
* | output |
* | --- |
* | "SMS" |
*
* @param {Integrations_Section_MessagingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_section_messaging = /** @type {((inputs?: Integrations_Section_MessagingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Section_MessagingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_section_messaging(inputs)
	return cs_integrations_section_messaging(inputs)
});